import { useMemo } from 'react';
import { useFeatureTheme } from '../../../theme/hooks/useFeatureTheme';

export function useActionMenuStyles() {
  const {
    semantic,
    spacing,
    radiusPx,
    shadows,
    typography,
    density,
  } = useFeatureTheme();

  return useMemo(
    () => ({
      paper: {
        minWidth: 188,
        maxWidth: 260,
        mt: 0.25,
        py: `${spacing.size4}px`,
        px: `${spacing.size4}px`,
        bgcolor: semantic.surfaces.surfaceElevated,
        borderRadius: `${radiusPx.lg}px`,
        border: `1px solid ${semantic.borders.border}`,
        boxShadow: shadows.sm,
      },
      list: {
        py: 0,
        display: 'flex',
        flexDirection: 'column',
        gap: `${spacing.size4 / 2}px`,
      },
      item: (destructive = false) => ({
        display: 'flex',
        alignItems: 'center',
        gap: `${spacing.size8}px`,
        minHeight: 32,
        py: `${spacing.size4}px`,
        px: `${spacing.size8}px`,
        borderRadius: `${radiusPx.sm}px`,
        color: destructive ? semantic.states.danger : semantic.text.primary,
        transition: 'background-color 120ms ease, color 120ms ease',
        '&:hover': {
          bgcolor: destructive ? semantic.states.dangerSoft : semantic.surfaces.surfaceMuted,
        },
        '&.Mui-focusVisible': {
          bgcolor: destructive ? semantic.states.dangerSoft : semantic.interactive.primarySoft,
        },
        '&.Mui-disabled': {
          opacity: 0.45,
        },
      }),
      icon: (destructive = false) => ({
        minWidth: 16,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: destructive ? semantic.states.danger : semantic.text.muted,
        '& .MuiSvgIcon-root': {
          fontSize: 16,
        },
      }),
      label: (destructive = false) => ({
        fontSize: typography.fontSizeSm,
        fontWeight: destructive
          ? typography.fontWeightMedium
          : typography.fontWeightRegular,
        lineHeight: typography.lineHeightTight,
        letterSpacing: '-0.01em',
        whiteSpace: 'nowrap',
      }),
      divider: {
        my: `${spacing.size4}px`,
        borderColor: semantic.borders.border,
      },
      triggerOpen: {
        color: semantic.interactive.primary,
        bgcolor: semantic.interactive.primarySoft,
      },
      triggerIdle: {
        color: semantic.text.muted,
        bgcolor: 'transparent',
      },
      itemHeight: density.compact.controlHeight - 2,
    }),
    [density.compact.controlHeight, radiusPx.lg, radiusPx.sm, semantic, shadows.sm, spacing.size4, spacing.size8, typography]
  );
}

export default useActionMenuStyles;
